<script>
// Channel renderer. (Keltner, Bollinger)
// TODO: allow color transparency
// TODO: improve performance: draw in one solid chunk
import Overlay from '../../mixins/overlay.js'
import { drawIndicatorPlot } from '../../workspace/indicator-plots.mjs'

export default {
    name: 'Channel',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return { author: 'C451', version: '1.0.1' }
        },
        /*draw(ctx) {
            ctx.lineWidth = this.line_width
            ctx.strokeStyle = this.color
            ctx.fillStyle = this.back_color

            for (var i = 0; i < this.$props.data.length - 1; i++) {


                let p1 = this.mapp(this.$props.data[i])
                let p2 = this.mapp(this.$props.data[i+1])

                if (!p2) continue
                if (p1.y1 !== p1.y1) continue // Fix NaN

                // Background
                ctx.beginPath()
                ctx.moveTo(p1.x, p1.y1)
                ctx.lineTo(p2.x + 0.1, p2.y1)
                ctx.lineTo(p2.x + 0.1, p2.y3)
                ctx.lineTo(p1.x, p1.y3)
                ctx.fill()

                // Lines
                ctx.beginPath()
                ctx.moveTo(p1.x, p1.y1)
                ctx.lineTo(p2.x, p2.y1)
                if (this.show_mid) {
                    ctx.moveTo(p1.x, p1.y2)
                    ctx.lineTo(p2.x, p2.y2)
                }
                ctx.moveTo(p1.x, p1.y3)
                ctx.lineTo(p2.x, p2.y3)
                ctx.stroke()

            }
        },*/

        draw(ctx) {
            // Background
            const data = this.data
            const layout = this.layout
            ctx.beginPath()
            ctx.fillStyle = this.back_color
            for (var i = 0; i < data.length; i++) {
                let p = data[i]
                let x = layout.t2screen(p[0])
                let y = layout.$2screen(p[1] ?? undefined)
                ctx.lineTo(x, y)
            }
            for (var i = data.length - 1; i >= 0; i--) {
                let p = data[i]
                let x = layout.t2screen(p[0])
                let y = layout.$2screen(p[3] ?? undefined)
                ctx.lineTo(x, y)
            }
            ctx.fill()

            drawIndicatorPlot(ctx, data, layout, this.sett, 0, {color:this.top_color,width:this.line_width})
            drawIndicatorPlot(ctx, data, layout, this.sett, 2, {color:this.bottom_color,width:this.line_width})
            if (this.show_mid) drawIndicatorPlot(ctx, data, layout, this.sett, 1, {color:this.color,width:this.line_width})
        },

        mapp(p) {
            const layout = this.$props.layout
            return p && {
                x:  layout.t2screen(p[0]),
                y1: layout.$2screen(p[1]),
                y2: layout.$2screen(p[2]),
                y3: layout.$2screen(p[3])
            }
        },
        use_for() { return ['Channel', 'KC', 'BB', 'DC'] },
        data_colors() { return [this.top_color, this.color, this.bottom_color] },
        _mildify(color) {
            // Convert strong colors to milder versions for dark theme
            if (color.startsWith('rgba')) {
                // Reduce opacity for dark theme
                return color.replace(/,\s*[\d.]+\)$/, ', 0.45)')
            }
            if (color.startsWith('rgb(')) {
                // Convert to rgba with reduced opacity
                return color.replace('rgb(', 'rgba(').replace(')', ', 0.45)')
            }
            // Hex or named colors - return with opacity
            return color
        }
    },
    // Define internal setting & constants here
    computed: {
        sett() {
            return this.$props.settings
        },
        is_dark() {
            const back = this.$props.colors ? this.$props.colors.back : ''
            return back && back !== '#fff' && back !== '#ffffff' && back !== 'white'
        },
        line_width() {
            return this.sett.lineWidth || 0.75
        },
        color() {
            const output = this.sett.$plotConfig && this.sett.$plotConfig.outputs && this.sett.$plotConfig.outputs[1]
            if (output && output.color) return output.color
            const n = this.$props.num % 5
            if (this.sett.color) return this.sett.color
            if (this.is_dark) return 'rgba(120, 130, 150, 0.3)'
            return this.COLORS[n]
        },
        top_color() {
            const output = this.sett.$plotConfig && this.sett.$plotConfig.outputs && this.sett.$plotConfig.outputs[0]
            if (output && output.color) return output.color
            if (this.sett.topColor) {
                if (this.is_dark) return this._mildify(this.sett.topColor)
                return this.sett.topColor
            }
            return this.color
        },
        bottom_color() {
            const output = this.sett.$plotConfig && this.sett.$plotConfig.outputs && this.sett.$plotConfig.outputs[2]
            if (output && output.color) return output.color
            if (this.sett.bottomColor) {
                if (this.is_dark) return this._mildify(this.sett.bottomColor)
                return this.sett.bottomColor
            }
            return this.color
        },
        show_mid() {
            return 'showMid' in this.sett ? this.sett.showMid : true
        },
        back_color() {
            if (this.sett.backColor) {
                if (this.is_dark) return 'rgba(80, 90, 110, 0.08)'
                return this.sett.backColor
            }
            if (this.is_dark) return 'rgba(80, 90, 110, 0.08)'
            return this.color + '11'
        }
    },
    data() {
        return {
            COLORS:
            [
                '#42b28a', '#5691ce', '#612ff9',
                '#d50b90', '#ff2316'
            ]
        }
    }

}
</script>
